var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stock-ad-view"},[_c('StockAD')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }